"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isUAT = exports.isStaging = exports.getMissEvanSiteMain = exports.getMissEvanMobileAPIPrefixURL = exports.getMissEvanLinkPrefixURL = exports.getMissEvanFMAPIPrefixURL = exports.getMissEvanDataPrefixURL = exports.getMissEvanCDNPrefixURL = exports.getMissEvanAppPrefixURL = exports.getMissEvanAPIPrefixURL = exports.MISSEVAN_SITE_MAIN = exports.MISSEVAN_MOBILE_API_PREFIX_URL = exports.MISSEVAN_LINK_PREFIX_URL = exports.MISSEVAN_FM_API_PREFIX_URL = exports.MISSEVAN_ENV = exports.MISSEVAN_DATA_PREFIX_URL = exports.MISSEVAN_CDN_PREFIX_URL = exports.MISSEVAN_APP_SCHEME_PREFIX = exports.MISSEVAN_APP_PREFIX_URL = exports.MISSEVAN_API_PREFIX_URL = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url-search-params"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var disableDebugParams = ['0', 'false'];
var urlParams = new _urlSearchParams.default(window.location.search);
var debugParam = urlParams.get('debug');
var isDebug = !(debugParam && (0, _includes.default)(disableDebugParams).call(disableDebugParams, debugParam));
var ENV_STAGING = process.env.STAGING;

var checkStagingEnv = function checkStagingEnv() {
  if (typeof ENV_STAGING === 'string') {
    return ENV_STAGING !== 'false';
  }

  if (typeof ENV_STAGING === 'boolean') {
    return ENV_STAGING;
  }

  return true;
};

var isStaging = checkStagingEnv();
exports.isStaging = isStaging;
var isUAT = isStaging && isDebug;
exports.isUAT = isUAT;
var MISSEVAN_ENV = isUAT ? 'uat.' : '';
exports.MISSEVAN_ENV = MISSEVAN_ENV;

var getMissEvanSiteMain = function getMissEvanSiteMain() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://www.".concat(uat ? 'uat.' : '', "missevan.com");
};

exports.getMissEvanSiteMain = getMissEvanSiteMain;
var MISSEVAN_SITE_MAIN = getMissEvanSiteMain();
exports.MISSEVAN_SITE_MAIN = MISSEVAN_SITE_MAIN;
var getMissEvanAPIPrefixURL = getMissEvanSiteMain;
exports.getMissEvanAPIPrefixURL = getMissEvanAPIPrefixURL;
var MISSEVAN_API_PREFIX_URL = getMissEvanAPIPrefixURL();
exports.MISSEVAN_API_PREFIX_URL = MISSEVAN_API_PREFIX_URL;

var getMissEvanDataPrefixURL = function getMissEvanDataPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://data.".concat(uat ? 'uat.' : '', ".missevan.com");
};

exports.getMissEvanDataPrefixURL = getMissEvanDataPrefixURL;
var MISSEVAN_DATA_PREFIX_URL = getMissEvanDataPrefixURL();
exports.MISSEVAN_DATA_PREFIX_URL = MISSEVAN_DATA_PREFIX_URL;

var getMissEvanMobileAPIPrefixURL = function getMissEvanMobileAPIPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://m.".concat(uat ? 'uat.' : '', "missevan.com");
};

exports.getMissEvanMobileAPIPrefixURL = getMissEvanMobileAPIPrefixURL;
var MISSEVAN_MOBILE_API_PREFIX_URL = getMissEvanMobileAPIPrefixURL();
exports.MISSEVAN_MOBILE_API_PREFIX_URL = MISSEVAN_MOBILE_API_PREFIX_URL;

var getMissEvanFMAPIPrefixURL = function getMissEvanFMAPIPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://fm.".concat(uat ? 'uat.' : '', "missevan.com");
};

exports.getMissEvanFMAPIPrefixURL = getMissEvanFMAPIPrefixURL;
var MISSEVAN_FM_API_PREFIX_URL = getMissEvanFMAPIPrefixURL();
exports.MISSEVAN_FM_API_PREFIX_URL = MISSEVAN_FM_API_PREFIX_URL;

var getMissEvanAppPrefixURL = function getMissEvanAppPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://app.".concat(uat ? 'uat.' : '', "missevan.com");
};

exports.getMissEvanAppPrefixURL = getMissEvanAppPrefixURL;
var MISSEVAN_APP_PREFIX_URL = getMissEvanAppPrefixURL();
exports.MISSEVAN_APP_PREFIX_URL = MISSEVAN_APP_PREFIX_URL;

var getMissEvanLinkPrefixURL = function getMissEvanLinkPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://link.".concat(uat ? 'uat.' : '', "missevan.com");
};

exports.getMissEvanLinkPrefixURL = getMissEvanLinkPrefixURL;
var MISSEVAN_LINK_PREFIX_URL = getMissEvanLinkPrefixURL();
exports.MISSEVAN_LINK_PREFIX_URL = MISSEVAN_LINK_PREFIX_URL;

var getMissEvanCDNPrefixURL = function getMissEvanCDNPrefixURL() {
  var uat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isUAT;
  return "https://static".concat(uat ? '-test' : '', ".maoercdn.com");
};

exports.getMissEvanCDNPrefixURL = getMissEvanCDNPrefixURL;
var MISSEVAN_CDN_PREFIX_URL = getMissEvanCDNPrefixURL();
exports.MISSEVAN_CDN_PREFIX_URL = MISSEVAN_CDN_PREFIX_URL;
var MISSEVAN_APP_SCHEME_PREFIX = 'missevan:/';
exports.MISSEVAN_APP_SCHEME_PREFIX = MISSEVAN_APP_SCHEME_PREFIX;